import { apiClient } from './apiClient';
import type { PermittedPerson } from '@/contexts/EnteringForContext';

/** A person returned by GET /timesheets/permitted-people. */
export interface PermittedPersonApiResponse {
  id: number;
  name: string;
  email?: string | null;
  department?: string | null;
  type?: string | null;
  resourceId?: number | null;
  isContractor: boolean;
  requiresApproval: boolean;
  roleId?: number | null;
  roleName?: string | null;
}

/**
 * Fetches the resources and contractors the current user may enter time for, resolved
 * server-side from the organisation's On Behalf Of settings.
 */
export async function fetchPermittedPeople(): Promise<PermittedPerson[]> {
  const people = await apiClient.get<PermittedPersonApiResponse[]>('/timesheets/permitted-people');
  return people.map(person => ({
    id: String(person.id),
    name: person.name,
    employeeId: person.id,
    department: person.department ?? null,
    resourceId: person.resourceId ?? null,
    isContractor: person.isContractor,
    requiresApproval: person.requiresApproval,
    roleId: person.roleId ?? undefined,
    roleName: person.roleName ?? undefined,
  }));
}
